module.exports = __webpack_public_path__ + "static/img/mbk-pickup-delivery.62de376.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/mbk-pickup-delivery.jpg
// module id = HuH3
// module chunks = 0